import {createSlice} from '@reduxjs/toolkit';
import reducers from './reducers'
import extraReducers from './extraReducers'

export * from '../../thunk/mockupsCompareStats';

const MockupsCompareStatsSlice = createSlice({
    name: "mockupsCompareStats",
    initialState: {
        data: {},
        status: null,
        error: null,
        queryParams: null,
    },
    reducers,
    extraReducers
});
const {actions, reducer} = MockupsCompareStatsSlice;
export const {clearFilters} = actions;
export {reducer}; 